var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookMessenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "url(#paint0_radial_223_11963)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 24.0777C13.3333 17.2669 18.6713 12.2222 25.5555 12.2222C32.4396 12.2222 37.7777 17.2699 37.7777 24.0808C37.7777 30.8916 32.4396 35.9363 25.5555 35.9363C24.318 35.9363 23.1324 35.7713 22.0171 35.4658C21.8002 35.4077 21.568 35.423 21.3633 35.5147L18.9371 36.5841C18.3016 36.8652 17.5866 36.413 17.5652 35.7194L17.498 33.5438C17.4919 33.2749 17.3696 33.0244 17.171 32.8472C14.7938 30.7205 13.3333 27.6405 13.3333 24.0777ZM21.8061 21.8506L18.2158 27.5461C17.8705 28.0931 18.5427 28.7072 19.0561 28.3161L22.9122 25.3889C23.1719 25.1903 23.5325 25.1903 23.7952 25.3859L26.6522 27.5278C27.5108 28.1695 28.733 27.9464 29.3044 27.0389L32.8977 21.3464C33.2399 20.7995 32.5677 20.1822 32.0544 20.5734L28.1983 23.5006C27.9386 23.6992 27.578 23.6992 27.3152 23.5036L24.4583 21.3617C23.5997 20.72 22.3775 20.9431 21.8061 21.8506Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_223_11963",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.625 49.7317) scale(54.48 54.4752)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6098,
    stopColor: "#A033FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9348,
    stopColor: "#FF5280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7061"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookMessenger);
export default __webpack_public_path__ + "static/media/Facebook Messenger.e1bb45080a5405966096e093527f8ada.svg";
export { ForwardRef as ReactComponent };